import { Platform, Pressable, StyleSheet, Text, View } from 'react-native';
import { router } from 'expo-router';
import { theme } from '@/constants/theme';

const SURFACE  = '#16142A';
const TEXT_MED = '#9896B4';
const AMBER    = '#F59E0B';

type Props = {
  userId: string;
  primaryColor?: string;
};

export function KpGuestMergeBanner({ userId, primaryColor }: Props) {
  const isGuest = !userId || userId.startsWith('guest_');
  if (!isGuest) return null;

  const accent = primaryColor ?? theme.colors.primary;

  return (
    <View style={[s.banner, { borderColor: accent + '33' }]}>
      <View style={s.bannerTop}>
        <Text style={s.lockIcon}>🔓</Text>
        <View style={{ flex: 1 }}>
          <Text style={s.bannerTitle}>שמור את ההתקדמות שלך</Text>
          <Text style={s.bannerSub}>התחבר כדי לא לאבד XP בסגירת הדף</Text>
        </View>
      </View>
      <Pressable
        style={[s.btn, { backgroundColor: accent }]}
        onPress={() => router.push('/lead-gate' as any)}
        accessibilityRole="button"
      >
        <Text style={s.btnText}>התחברות / הרשמה →</Text>
      </Pressable>
    </View>
  );
}

const s = StyleSheet.create({
  banner: {
    backgroundColor: SURFACE,
    borderRadius: 14,
    borderWidth: 1,
    padding: 14,
    gap: 12,
    alignItems: 'stretch',
    ...(Platform.OS === 'web' ? ({ boxShadow: '0 4px 16px rgba(0,0,0,0.3)' } as any) : {}),
  },
  bannerTop: {
    flexDirection: 'row-reverse',
    alignItems: 'center',
    gap: 10,
  },
  lockIcon: { fontSize: 20 },
  bannerTitle: {
    fontFamily: theme.fonts.bold,
    fontSize: 14,
    color: AMBER,
    textAlign: 'right',
  },
  bannerSub: {
    fontFamily: theme.fonts.regular,
    fontSize: 12,
    color: TEXT_MED,
    textAlign: 'right',
    marginTop: 2,
    lineHeight: 17,
  },
  btn: {
    borderRadius: 10,
    paddingVertical: 11,
    paddingHorizontal: 20,
    alignItems: 'center',
  },
  btnText: {
    color: '#fff',
    fontFamily: theme.fonts.bold,
    fontSize: 14,
  },
});
